// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","whirlpool":"Loader_whirlpool__3Ln4v","cssload-rotate":"Loader_cssload-rotate__1G-Id"};